import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import COLOR_MAP from '../../../../constants/color-mapping';
import PopoverInfoIcon from '../../../../components/PopoverInfoIcon/PopoverInfoIcon';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const GeriatricPrecautions = forwardRef(function (
  { geriatricPrecautions },
  ref,
) {
  return (
    <div
      ref={ref}
      className="mb-36 scroll-offset"
      id="geriatric-precautions-section"
    >
      <h4 className="accordion-header">Geriatric Precautions</h4>

      <div className="accordion-body">
        {geriatricPrecautions?.Geriatric_Precautions?.length ? (
          <div>
            <ul className="indicator">
              {geriatricPrecautions.Geriatric_Precautions.map(
                (geriatricPrecaution, index) => (
                  <div key={`geriatric-precaution-${index}`}>
                    <li className="f-18 font-semibold">
                      {geriatricPrecaution.PrecautionsGeriatricDesc}
                    </li>

                    <div className="">
                      <div className="row">
                        <div className="col-sm-6 col-12 drug-info">
                          <label>
                            Severity Description
                            <PopoverInfoIcon
                              popoverInfo={COLOR_MAP.GeriatricPrecautions}
                            />
                          </label>
                          <p>
                            <span
                              className={
                                COLOR_MAP.GeriatricPrecautions[
                                  geriatricPrecaution.SeverityDesc
                                ]
                              }
                            />
                            {geriatricPrecaution.SeverityDesc}
                          </p>
                        </div>
                        <div className="col-sm-6 col-12 drug-info">
                          <label>Precautions Description</label>
                          <p>{geriatricPrecaution.Narrative}</p>
                        </div>
                        <div className="col-sm-6 col-12 drug-info">
                          <label className="label mb-2">Risks</label>
                          <ul className="risk-list">
                            <li>
                              <span className="fw-normal me-0">
                                Cardiovascular Risk
                              </span>
                              <span
                                className={
                                  'answer ' +
                                  (geriatricPrecaution.HasCardiovascularRisk
                                    ? 'red-color'
                                    : '')
                                }
                              >
                                {geriatricPrecaution.HasCardiovascularRisk
                                  ? 'Yes'
                                  : 'No'}
                              </span>
                            </li>
                            <li>
                              <span className="fw-normal me-0">
                                Neurological Risk
                              </span>
                              <span
                                className={
                                  'answer ' +
                                  (geriatricPrecaution.HasNeurologicalRisk
                                    ? 'red-color'
                                    : '')
                                }
                              >
                                {geriatricPrecaution.HasNeurologicalRisk
                                  ? 'Yes'
                                  : 'No'}
                              </span>
                            </li>
                            <li>
                              <span className="fw-normal me-0">
                                Endocrine Risk
                              </span>
                              <span
                                className={
                                  'answer ' +
                                  (geriatricPrecaution.HasEndocrineRisk
                                    ? 'red-color'
                                    : '')
                                }
                              >
                                {geriatricPrecaution.HasEndocrineRisk
                                  ? 'Yes'
                                  : 'No'}
                              </span>
                            </li>
                            <li>
                              <span className="fw-normal me-0">
                                Hepatic Risk
                              </span>
                              <span
                                className={
                                  'answer ' +
                                  (geriatricPrecaution.HasHepaticRisk
                                    ? 'red-color'
                                    : '')
                                }
                              >
                                {geriatricPrecaution.HasHepaticRisk
                                  ? 'Yes'
                                  : 'No'}
                              </span>
                            </li>
                            <li>
                              <span className="fw-normal me-0">
                                Pulmonary Risk
                              </span>
                              <span
                                className={
                                  'answer ' +
                                  (geriatricPrecaution.HasPulmonaryRisk
                                    ? 'red-color'
                                    : '')
                                }
                              >
                                {geriatricPrecaution.HasPulmonaryRisk
                                  ? 'Yes'
                                  : 'No'}
                              </span>
                            </li>
                            <li>
                              <span className="fw-normal me-0">Renal Risk</span>
                              <span
                                className={
                                  'answer ' +
                                  (geriatricPrecaution.HasRenalRisk
                                    ? 'red-color'
                                    : '')
                                }
                              >
                                {geriatricPrecaution.HasRenalRisk
                                  ? 'Yes'
                                  : 'No'}
                              </span>
                            </li>
                            <li>
                              <span className="fw-normal me-0">Beers List</span>
                              <span
                                className={
                                  'answer ' +
                                  (geriatricPrecaution.IsOnBeersList
                                    ? 'red-color'
                                    : '')
                                }
                              >
                                {geriatricPrecaution.IsOnBeersList
                                  ? 'Yes'
                                  : 'No'}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ),
              )}
            </ul>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
});

GeriatricPrecautions.propTypes = {
  geriatricPrecautions: PropTypes.object.isRequired,
};

GeriatricPrecautions.displayName = 'GeriatricPrecautions';

export default GeriatricPrecautions;
